import React, { useState, useEffect } from "react";
// import { convertFromHTML, convertFromRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertToRaw,
  // htmlToDraft,
} from "draft-js";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { useHistory } from "react-router-dom";
import "./styles/style.css";
import {
  Button,
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Text,
  makeStyles,
  shorthands,
  typographyStyles,
  Label,
  Switch,
  Tab,
  TabList,
  Spinner,
  Field,
  Skeleton,
  SkeletonItem,
} from "@fluentui/react-components";
import { Icon } from "@fluentui/react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import axios from "axios";
import ThemeSelector from "./ThemeSelector.js";

import ExampleFormFirstPage from "./ExampleFormFirstPage.js";
import ExampleFormThirdPage from "./ExampleFormThirdPage.js";

import ExampleFormSecondPage from "./ExampleFormSecondPage.js";
import { useTranslation } from "react-i18next";
import { useMsal, useAccount } from "@azure/msal-react";
import { silentRequest } from "../../authConfig.js";
import ManagementQrCode from "./ManagementQrCode.js";
import {
  Toaster,
  useToastController,
  ToastTitle,
  ToastTrigger,
  Toast,
  useId,
  Link,
  Divider,
} from "@fluentui/react-components";
import ManagementPolicyPrivacy from "./ManagementPolicyPrivacy.js";

// MSAL imports

// import NotSubscribed from "./NotSubscribed.js";
const API_URL_FORM = process.env.REACT_APP_REQUEST_FORM_API_URL;
const API_URL = process.env.REACT_APP_API_URL;

const useStyles = makeStyles({
  root: {
    // Stack the label above the field with a gap
    display: "grid",
    gridTemplateRows: "repeat(1fr)",
    justifyItems: "start",
    ...shorthands.gap("20px"),
    maxWidth: "400px",
    "> div": {
      display: "grid",
      gridTemplateRows: "repeat(1fr)",
      justifyItems: "start",
      ...shorthands.gap("2px"),
      // need padding to see the background color for filled variants
      ...shorthands.padding("5px", "20px", "10px"),
    },
  },
  title: { ...typographyStyles.subtitle1, textAlign: "center" },
  languagechange: typographyStyles.subtitle2,

  tabTheme: {
    display: "flex",
    flexDirection: "column",

    ...shorthands.padding("10px", "20px"),
    marginLeft: "-30px",
  },
});

const ManagementForm = () => {
  // const [savedData, setSavedData] = useState("default");
  // const [editorState, setEditorState] = useState(() => {
  //   const content = ContentState.createFromText(savedData);
  //   return EditorState.createWithContent(content);
  // });
const { t,i18n } = useTranslation();
const localization = {

  th : {
  locale: "th",
  translations: {
    "generic.add": "เพิ่ม",
    "generic.cancel": "ยกเลิก",

    // BlockType
    "components.controls.blocktype.h1": "หัวเรื่อง 1",
    "components.controls.blocktype.h2": "หัวเรื่อง 2",
    "components.controls.blocktype.h3": "หัวเรื่อง 3",
    "components.controls.blocktype.h4": "หัวเรื่อง 4",
    "components.controls.blocktype.h5": "หัวเรื่อง 5",
    "components.controls.blocktype.h6": "หัวเรื่อง 6",
    "components.controls.blocktype.blockquote": "อ้างอิง",
    "components.controls.blocktype.code": "โค้ด",
    "components.controls.blocktype.blocktype": "บล็อก",
    "components.controls.blocktype.normal": "ปกติ",

    // Color Picker
    "components.controls.colorpicker.colorpicker": "ตัวเลือกสี",
    "components.controls.colorpicker.text": "สีตัวอักษร",
    "components.controls.colorpicker.background": "สีพื้นหลัง",

    // Embedded
    "components.controls.embedded.embedded": "ฝัง",
    "components.controls.embedded.embeddedlink": "ลิงก์ฝัง",
    "components.controls.embedded.enterlink": "ใส่ลิงก์",

    // Emoji
    "components.controls.emoji.emoji": "อีโมจิ",

    // FontFamily
    "components.controls.fontfamily.fontfamily": "แบบอักษร",

    // FontSize
    "components.controls.fontsize.fontsize": "ขนาดตัวอักษร",

    // History
    "components.controls.history.history": "ประวัติ",
    "components.controls.history.undo": "ย้อนกลับ",
    "components.controls.history.redo": "ทำซ้ำ",

    // Image
    "components.controls.image.image": "รูปภาพ",
    "components.controls.image.fileUpload": "อัปโหลดไฟล์",
    "components.controls.image.byURL": "ตาม URL",
    "components.controls.image.dropFileText":
      "ลากไฟล์หรือคลิกเพื่ออัปโหลด",

    // Inline
    "components.controls.inline.bold": "ตัวหนา",
    "components.controls.inline.italic": "ตัวเอียง",
    "components.controls.inline.underline": "ขีดเส้นใต้",
    "components.controls.inline.strikethrough": "ขีดฆ่า",
    "components.controls.inline.monospace": "Mono space",
    "components.controls.inline.superscript": "ตัวยก",
    "components.controls.inline.subscript": "ตัวห้อย",

    // Link
    "components.controls.link.linkTitle": "ชื่อของลิงก์",
    "components.controls.link.linkTarget": "ลิงก์เป้าหมาย",
    "components.controls.link.linkTargetOption": "เปิดลิงก์ในหน้าต่างใหม่",
    "components.controls.link.link": "เพิ่มลิงก์",
    "components.controls.link.unlink": "ลบลิงก์",

    // List
    "components.controls.list.list": "รายการ",
    "components.controls.list.unordered": "สัญลักษณ์แสดงหัวข้อย่อย",
    "components.controls.list.ordered": "ลำดับตัวเลข",
    "components.controls.list.indent": "ย่อหน้า",
    "components.controls.list.outdent": "ลดการย่อหน้า",

    // Remove
    "components.controls.remove.remove": "ลบ",

    // TextAlign
    "components.controls.textalign.textalign": "การจัดตำแหน่งข้อความ",
    "components.controls.textalign.left": "ชิดซ้าย",
    "components.controls.textalign.center": "กึ่งกลาง",
    "components.controls.textalign.right": "ชิดขวา",
    "components.controls.textalign.justify": "จัดให้พอดี",
  },
},
en:{
  locale: "en",
  translations: { 
  "generic.add": "Add",
  "generic.cancel": "Cancel",
  "components.controls.blocktype.h1": "Header 1",
  "components.controls.blocktype.h2": "Header 2",
  "components.controls.blocktype.h3": "Header 3",
  "components.controls.blocktype.h4": "Header 4",
  "components.controls.blocktype.h5": "Header 5",
  "components.controls.blocktype.h6": "Header 6",
  "components.controls.blocktype.blockquote": "Block Quote",
  "components.controls.blocktype.code": "Code",
  "components.controls.blocktype.blocktype": "Block",
  "components.controls.blocktype.normal": "Normal",
  "components.controls.colorpicker.colorpicker": "Color picker",
  "components.controls.colorpicker.text": "Text",
  "components.controls.colorpicker.background": "Background Color",
  "components.controls.embedded.embedded": "Embedded",
  "components.controls.embedded.embeddedlink": "Embedded Link",
  "components.controls.embedded.enterlink": "Insert Link",
  "components.controls.emoji.emoji": "Emoji",
  "components.controls.fontfamily.fontfamily": "Font Family",
  "components.controls.fontsize.fontsize": "Font Size",
  "components.controls.history.history": "History",
  "components.controls.history.undo": "Undo",
  "components.controls.history.redo": "Redo",
  "components.controls.image.image": "Image",
  "components.controls.image.fileUpload": "File Upload",
  "components.controls.image.byURL": "By URL",
  "components.controls.image.dropFileText": "Drop File Text Or Click Upload",
  "components.controls.inline.bold": "Bold",
  "components.controls.inline.italic": "Italic",
  "components.controls.inline.underline": "Underline",
  "components.controls.inline.strikethrough": "Strike Through",
  "components.controls.inline.monospace": "Mono Space",
  "components.controls.inline.superscript": "Super Script",
  "components.controls.inline.subscript": "Sub Script",
  "components.controls.link.linkTitle": "Link Title",
  "components.controls.link.linkTarget": "Link Target",
  "components.controls.link.linkTargetOption": "Link Target Option",
  "components.controls.link.link": "Add Link",
  "components.controls.link.unlink": "Delete Link",
  "components.controls.list.list": "List",
  "components.controls.list.unordered": "Unordered",
  "components.controls.list.ordered": "Ordered",
  "components.controls.list.indent": "Indent",
  "components.controls.list.outdent": "Outdent",
  "components.controls.textalign.textalign": "Text Align",
  "components.controls.textalign.left": "Left",
  "components.controls.textalign.center": "Center",
  "components.controls.textalign.right": "Right",
  "components.controls.textalign.justify": "Justify"
  }
}
};

 const [locale, setLocale] = useState(i18n?.language);

useEffect(() => {
    setLocale(i18n.language);  // Update locale based on i18n language
  }, [i18n?.language]);



  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  // const [accountData, setAccountData] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [companyDetailData, setCompanyDetailData] = useState(null);
  const [themeLoading, setThemeLoading] = useState(true);
  const [logoLoading, setLogoLoading] = useState(true);
  const [urlId, seturlId] = useState(null);
  const [logoIsHere,setLogoIsHere] = useState(false)
  const [logoIsHereForCompare,setLogoIsHereForCompare] = useState(false)
  const [checkBillingLoading,setCheckBillingLoading] =useState(true)
  // const companyId = sessionStorage.getItem('companyId') || '';
  const history = useHistory();
  async function fetchCompanyData() {
    // console.log('userEffect retrieve company and accounts data!');
 
    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {

        axios
          .get(API_URL + "/etax/companies", {
            headers: {
              Authorization: "Bearer " + tokenResponse.accessToken,
            },
          })
          .then(
            (response) => {
              console.log("response /etax/companies", response.data);

              if (response.data.length === 0) {
              } else {
                let _cid = "";
                if (
                  sessionStorage.getItem("companyId") &&
                  response.data.find(
                    (_company) =>
                      _company.id === sessionStorage.getItem("companyId")
                  )
                ) {
                  const _company = response.data.find(
                    (_company) =>
                      _company.id === sessionStorage.getItem("companyId")
                  );
                  setCompanyData(_company);
                  console.log("companyData", companyData);
                  // console.log(_company)

                  // sessionStorage.setItem("companyId", response.data[0].id);
                  _cid = sessionStorage.getItem("companyId");
                } else {
                  const _company = response.data[0];

                  setCompanyData(_company);
                  sessionStorage.setItem("companyId", _company.id);

                  _cid = _company.id;
                }

                axios
                  // .get(API_URL + '/companies-details/' + response.data[0].id, {
                  .get(API_URL + "/companies-details", {
                    headers: {
                      Authorization: "Bearer " + tokenResponse.accessToken,
                      "cid": _cid,
                    },
                  })
                  .then((companiesDetailsResponse) => {
                    // console.log('companiesDetailsResponse: ', companiesDetailsResponse);
                    if (companiesDetailsResponse.data) {
                      setCompanyDetailData(companiesDetailsResponse.data);
                    }
                    // console.log("CompanyDetail", companiesDetailsResponse.data);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            },
            (error) => {
              console.log(error);
            }
          );

        axios
          .get(API_URL + "/accounts", {
            headers: {
              Authorization: "Bearer " + tokenResponse.accessToken,
            },
          })
          .then(
            (response) => {
              // console.log(response);

              if (response.data) {
                // setAccountData(response.data);
              }
            },
            (error) => {
              console.log(error);
            }
          );
        
   
      })
      .catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);
       
      });
  }

  useEffect(() => {
    fetchCompanyData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const billingsTypeStorage = sessionStorage.getItem("billingsType") || "";

  useEffect(() => {
    console.log("billingsTypeStorage", billingsTypeStorage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [formId, setFormId] = useState(null);

  const toasterId = useId("toaster");
  const { dispatchToast } = useToastController(toasterId);

  const EditConfirm = () =>
    dispatchToast(
      <Toast>
        <ToastTitle
          action={
            <ToastTrigger>
              <Link>Dismiss</Link>
            </ToastTrigger>
          }
        >
          {t("requestFormAdminFormEditor.saveSuccessfully")}
        </ToastTitle>
      </Toast>,
      { intent: "success" }
    );

  const [timeout, setDismissTimeout] = useState(0);
  const inProgress = () =>
    dispatchToast(
      <Toast >
        <ToastTitle
          
          media={<Spinner size="tiny" />}
        >
         {t("requestFormAdminFormEditor.sendingData")}
        </ToastTitle>
      </Toast>,
    { timeout, intent: "info" }
    );


  const CopySuccess = () =>
    dispatchToast(
      <Toast>
        <ToastTitle
          action={
            <ToastTrigger>
              <Link>Dismiss</Link>
            </ToastTrigger>
          }
        >
          {t("requestFormAdminFormEditor.copyLinkAlready")}
        </ToastTitle>
      </Toast>,
      { intent: "success" }
    );

  const EditUnsuccess = () =>
    dispatchToast(
      <Toast>
        <ToastTitle
          action={
            <ToastTrigger>
              <Link>Dismiss</Link>
            </ToastTrigger>
          }
        >
          {t("requestFormAdminFormEditor.saveUnsucess")}
        </ToastTitle>
      </Toast>,
      { intent: "error" }
    );

  const styles = useStyles();

  const [savedData, setSavedData] = useState(null);
  const [policyMessage,setPolicyMessage]=useState(null)

  const myBlockStyleFn = (contentBlock) => {
    const type = contentBlock.getType();
    if (type === "blockquote") {
      return "public-DraftStyleDefault";
    }
  };

  // class EditorWithFancyBlockquotes extends React.Component {
  //   render() {
  //     return <Editor blockStyleFn={myBlockStyleFn} />;
  //   }
  // }

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  // const [editorState, setEditorState] = React.useState(() => {
  //   if (savedData !== null) {
  //     const blocksFromHTML = htmlToDraft(savedData.previewText);
  //     const contentState = ContentState.createFromBlockArray(blocksFromHTML);
  //     return EditorState.createWithContent(contentState);
  //   }
  //   return EditorState.createEmpty();
  // });

  const [contentState, setContentState] = useState(null);
  const [editorStateSecend, setEditorStateSecend] = useState(
    EditorState.createEmpty()
  );
  const [contentStateSecend, setContentStateSecend] = useState(null);

  const [editorStateThird, setEditorStateThird] = useState(
    EditorState.createEmpty()
  );
  const [contentStateThird, setContentStateThird] = useState(null);

  // const [firstRender, setFirstRender] = useState(true);

  // const setLikeDatabase = () => {
  //   setContentState(savedData.previewText);
  //   console.log("editorState on Focus", editorState);
  //   console.log("contentState on Focus", contentState);
  // };

  const handleContentStateChange = (contentState) => {
    setContentState(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };

  // useEffect(() => {
  //   console.log("editorState  from useEFFECT", editorState);
  //   console.log("contentState  from useEFFECT", contentState);
  // }, [editorState, contentState]);

  // useEffect(() => {
  //   console.log("firstRender !!", firstRender);
  // }, [firstRender]);

  const handleEditorStateChange = (editorState) => {
    setEditorState(editorState);
    // let value = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    // setContentState(
    //   draftToHtml(convertToRaw(editorState.getCurrentContent()))
    // );

    // let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    // setEditorState(currentContentAsHTML);
    // setContentState(currentContentAsHTML);

    // console.log(
    //   "draft-js: EditorHandleState",
    //   draftToHtml(convertToRaw(editorState.getCurrentContent()))
    // );
    // console.log("editorState", editorState);
  };

  // onEditorStateChange: Function = (editorState) => {
  //   this.setState({
  //     editorState,
  //   });
  // };

  // const handleContentStateChangeSecend = (contentState) => {
  //   if (contentState.blocks) {
  //     setContentStateSecend(draftToHtml(contentState));
  //   }
  // };

  const handleEditorStateChangeSecend = (editorState) => {
    setEditorStateSecend(editorState);
    let value = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setContentStateSecend(value);
  };

  // const [convertedContent, setConvertedContent] = useState(null);
  // const convertContentToHTML = () => {
  //   let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
  //   setConvertedContent(currentContentAsHTML);
  // };

  // useEffect(() => {
  //   console.log("convertedContent", convertedContent);
  // }, [convertedContent]);

  // const handleContentStateChangeThird = (contentState) => {
  //   if (contentState.blocks) {
  //     setContentStateThird(draftToHtml(contentState));
  //   }
  // };

  const handleEditorStateChangeThird = (editorState) => {
    setEditorStateThird(editorState);
    let value = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setContentStateThird(value);
  };

  const [isLoadComplete, setIsLoadComplete] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // console.log("account data ข้อมูลปัจจุบัน", companyDetailData);

    if (companyDetailData && companyDetailData.billings) {
      switch (companyDetailData.billings.type) {
        case "subscription":
          setCheckBillingLoading(false)
          setCurrentCustom("qrCodeEdit");
          break;
        case "prepaid":
          // setCurrentCustom("notSubscribe");
           setCheckBillingLoading(false)
          history.push({
            pathname: `/request-forms/not-subscribed`,
          });
          break;
        default:
          // Handle other cases if necessary
          // setBillingsType("prepaid");
           setCheckBillingLoading(false)
          history.push({
            pathname: `/request-forms/not-subscribed`,
          });
          // setCurrentCustom("notSubscribe");
          break;
      }
    }

   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyDetailData]);

  const [currentCustom, setCurrentCustom] = useState("qrCodeEdit");
  const renderTabs = () => {
    return (
      <>
        <Tab
          value="tab1"
          onClick={() => {
            setLoading(true);
            setCurrentCustom("qrCodeEdit");
          }}
          disabled={currentCustom === "notSubscribe"  }
        >
          {" "}
          <Text
            style={{ color: "black" }}
            size={400}
            disabled={currentCustom === "notSubscribe"}
          >
            {t("requestFormAdminFormEditor.printQrCode")}
          </Text>
        </Tab>
        <Tab
          value="tab2"
          onClick={() => {
            setLoading(true);
            setCurrentCustom("pickTheme");
          }}
          disabled={currentCustom === "notSubscribe" }
        >
          {" "}
          <Text style={{ color: "black" }} size={400}>
            {t("requestFormAdminFormEditor.selectTheme")}
          </Text>
        </Tab>
        <Tab
          value="tab3"
          onClick={() => {
            setLoading(true);
            setCurrentCustom("addTextForm");
          }}
          disabled={currentCustom === "notSubscribe" }
        >
          <Text style={{ color: "black" }} size={400}>
            {t("requestFormAdminFormEditor.addingTextToForm")}
          </Text>
        </Tab>
          <Tab
          value="tab4"
          onClick={() => {
            setLoading(true);
            setCurrentCustom("managementPolicy");
          }}
          disabled={currentCustom === "notSubscribe" }
        >
          <Text style={{ color: "black" }} size={400}>
            {t("requestFormAdminFormEditor.addingPrivacyPolicy")}
          </Text>
        </Tab>
      </>
    );
  };

  // useEffect(() => {
  //   async function fetchData() {
  //     try {
  //       // const response = await axios.get(
  //       //   `http://localhost:5004/api/forms/${formId}`
  //       // );

  //       const response = await axios.get(`${API_URL}/forms/${formId}`);
  //       console.log("API_URL", API_URL);
  //       console.log("เทส azure api", response);
  //       setUrlID(response.data.urlName);
  //     } catch (error) {
  //       console.error("Error fetching data:", error.message);
  //     }
  //   }

  //   fetchData();
  // }, []);

  const handleSaveData = async () => {
    console.log("contentState from handle Save data", contentState);
    inProgress()
    setDismissTimeout(40000)
    try {
      let tokenResponse;
        try {
            tokenResponse = await instance.acquireTokenSilent({
            ...silentRequest,
            account: account,
            });
        } catch (error) {
            console.error("Error acquiring token: ", error);
            instance.acquireTokenRedirect(silentRequest);
            return; 
        }

      const response = await axios.patch(
        `${API_URL_FORM}/forms/${formId}`,
        {
          // Ensure the request payload is structured correctly

          "replace": "/message",
          "value": {
            "previewText": contentState,
            "previewTextSecond": contentStateSecend,
            "previewTextThird": contentStateThird,
          },
        },
        {
          headers: {
            Authorization: "Bearer " + tokenResponse.accessToken,
          },
        }
      );

      if (response.status === 200) {
        console.log("Data saved successfully");
        setDismissTimeout(0)
        EditConfirm();
        // Optionally, you can reset the state or show a success message to the user
      } else {
        setDismissTimeout(0)
        throw new Error("Failed to save data");
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      setDismissTimeout(0)
      EditUnsuccess();

      // Handle error: show error message to the user or retry saving
    }
  };


  

  useEffect(() => {
    if (savedData && savedData.previewText !== null) {
      // const blocksFromHTML = convertFromHTML(savedData.previewText);
      // const contentState = ContentState.createFromBlockArray(
      //   blocksFromHTML.contentBlocks,
      //   blocksFromHTML.entityMap
      // );
      // let contentState = stateFromHTML(savedData.previewText);
      // console.log("contentState ", contentState);
      // setEditorState(EditorState.createWithContent(contentState));
      // setTimeout(() => {
      //   setContentState(savedData.previewText);
      //   console.log("time out!!");
      //   console.log("saved Data preview", savedData.previewText);
      // }, 2000);

      // โค้ดเก่า orignal ก่อนแก้ไข
      // const blocksFromHTML = convertFromHTML(savedData.previewText);
      // const contentState = ContentState.createFromBlockArray(
      //   blocksFromHTML.contentBlocks,
      //   blocksFromHTML.entityMap
      // );
      // const editorState = EditorState.createWithContent(contentState);

      // console.log("saved Data preview", savedData.previewText);

      // console.log("previewTextEditorState", savedData.previewTextEditorState);

      // let editorStateFromServer = savedData.previewTextEditorState;
      // let htmlContent = convertFromHTML(savedData.previewText);
      // let html = stateFromHTML(savedData.previewText);

      // console.log("htmlContent", htmlContent);
      // console.log("html", html);
      // let editorState = EditorState.createWithContent(
      //   ContentState.createFromBlockArray(
      //     htmlContent.contentBlocks,
      //     htmlContent.entityMap
      //   )
      // );

      // console.log("editorState now", editorState);
      // // console.log("editorState preview", editorState);
      // setInitialValue(editorState);
      // setContentInitialValue(savedData.previewText);
      // setEditorState(editorState);
      // setContentState(savedData.previewText);

      // let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());

      // console.log("currentContentAsHTML", currentContentAsHTML);

      // console.log("currentContent", currentContentAsHTML);
      // convertContentToHTML();
      // console.log("convertedContent", currentContentAsHTML);

      // console.log("blockFrom HTML ", blocksFromHTML);
      // console.log("contentState  ", contentState);

      const html = savedData.previewText;
      const contentBlock = htmlToDraft(html);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState);
        setContentState(savedData.previewText);
      }
    }
    if (savedData && savedData.previewTextSecond !== null) {
      // const blocksFromHTMLSecend = convertFromHTML(savedData.previewTextSecond);
      // const contentStateSecend = ContentState.createFromBlockArray(
      //   blocksFromHTMLSecend.contentBlocks,
      //   blocksFromHTMLSecend.entityMap
      // );
      // const editorStateSecend =
      //   EditorState.createWithContent(contentStateSecend);

      // setInitialValueSecend(savedData.previewTextSecond);
      // setEditorStateSecend(editorStateSecend);
      // setContentStateSecend(savedData.previewTextSecond);

      const html = savedData.previewTextSecond;
      const contentBlock = htmlToDraft(html);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const editorState = EditorState.createWithContent(contentState);
        setEditorStateSecend(editorState);
        setContentStateSecend(savedData.previewTextSecond);
      }
    }

    if (savedData && savedData.previewTextThird !== null) {
      const html = savedData.previewTextThird;
      const contentBlock = htmlToDraft(html);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const editorState = EditorState.createWithContent(contentState);
        setEditorStateThird(editorState);
        setContentStateThird(savedData.previewTextThird);
      }
    }
  }, [savedData]);

  const handleSavePreviewFirst = () => {
    handleSaveData();
  };

 

  const [ThemeForm, setThemeForm] = useState({
    name: "ชายหาด",
    backgroundColor: "#F9E4B7",
    primaryColor: "#2E8BC0",
    secondaryColor: "#56C9D8",
    accentColor1: "#82E0AA",
  });

  const [isEnabled, setIsEnabled] = useState(null);

  // Function to toggle the form state
  const toggleFormState = async () => {
    try {
      // Make a POST request to the backend to toggle the form state
      setIsLoadComplete(false);
      // const response = await axios.post(
      //   "http://localhost:7071/api/FormCloseOpen  "

       let tokenResponse;
          try {
            tokenResponse = await instance.acquireTokenSilent({
            ...silentRequest,
            account: account,
            });
          } catch (error) {
            console.error("Error acquiring token: ", error);
            instance.acquireTokenRedirect(silentRequest);
            return; 
          }

      const response = await axios.patch(
        `${API_URL_FORM}/forms/${formId}`,
        {
          "replace": "/enabled",
          "value": !isEnabled,
        },
        {
          headers: {
            Authorization: "Bearer " + tokenResponse.accessToken,
          },
        }
      );

      console.log("response", response);

      if (response.data.statusCode === 200) {
        console.log("Form Status changed successfully");
        // Optionally, you can reset the state or show a success message to the user
      } else {
        throw new Error("Failed to Changed");
      }
    } catch (error) {
      console.error("Error toggling form state:", error);
    } finally {
      setIsEnabled((prevState) => !prevState);
      setIsLoadComplete(true);
    }
  };

  // Function to fetch initial form state when component mounts

  return (
    <>
  
    <div
      style={{
        width: "100%",
        height: "1400px",
        fontFamily: "Segoe UI, sans-serif",
        flexDirection: "column",
        backgroundColor: "#f8f8f8",
      }}
    >
  { checkBillingLoading ? 
  <div style={{
    position: "relative", // Ensure the spinner is constrained to this div
    width: "100%",
    height: "100%",
    
  }}>
    <div style={{
      position: "absolute",   // Makes the spinner fill the parent div
      top: 0,
      left: 0,
      width: "100%",          // Full width of the parent div
      height: "500px",         // Full height of the parent div
      display: "flex",
      justifyContent: "center", // Centers the spinner horizontally
      alignItems: "center",     // Centers the spinner vertically
      color: "black",
      fontSize:"20px"
    }}>
      <div style={{ marginRight: "10px", marginTop: "5px" }}>
        <Spinner  size="huge" label={t("requestFormAdminFormEditor.loading")} />
      </div>
    </div>
  </div> 
:   
  

      <div
        style={{
          display: "flex",
          width: "98%",
          minheight: "1100px",
          margin: "auto",
          fontFamily: "Segoe UI, sans-serif",
          flexDirection: "column",

          backgroundColor: "#f8f8f8",
          alignContent: "center",
        }}
      >
        <Toaster toasterId={toasterId} />
        <div
          style={{
            display: "flex",
            height: "250px",
            width: "100%",
            backgroundColor: "#f8f8f8",
            justifyContent: "flex-start",
            flexDirection: "column",

            position: "relative",
          }}
        >
          <div
            style={{
              display: "flex",
              textAlign: "left",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",

                width: "98%",

                position: "relative",
                justifyContent: "space-between",
                paddingBottom: "20px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",

                    width: "600px",
                    textAlign: "center",
                  }}
                >
                  <h2
                    className={styles.title}
                    style={{
                      color: "black",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                   
                    <Icon
                      iconName="DocumentManagement"
                      style={{ color: "#106ebe", marginRight: "2px" }}
                    />
                    {/* <i class="ms-Icon ms-Icon--Mail" aria-hidden="true"></i> */}
                    
                    {/* <Icon iconName="CompassNW"  /> */}
                    {/* <i class="ms-Icon ms-Icon--Mail" aria-hidden="true"></i> */}
                    {t("requestFormAdminFormEditor.menuEditForm")}
                  </h2>
                </div>
                <div
                  style={{
                    display: "flex",
                    textAlign: "left",
                    width: "600px",
                    marginLeft: "10px",
                  }}
                >
                  <div className={styles.tabTheme}>
                    <TabList
                      defaultSelectedValue="tab1"
                      selectTabOnFocus={true}
                    >
                      {renderTabs()}
                    </TabList>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "300px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignContent: "flex-start",
                  alignItems: "end",
                  height: "80px",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Text
                    style={{
                      marginLeft: "10px",
                      color: "black",
                      fontWeight: "bolder",
                      textAlign: "right",
                    }}
                    size={400}
                  >
                    {t("requestFormAdminFormEditor.closeForm")}
                  </Text>

                  {isLoadComplete ? (
                    <div style={{ display: "flex" }}>
                      <div>
                        <Switch
                          defaultChecked={isEnabled} // Set the initial checked state
                          onClick={() => {
                            toggleFormState();
                          }} // Call the toggleFormState function on click
                          style={{
                            color: "#16263D",
                            fontStyle: "#16263D",
                          }}
                          disabled={currentCustom === "notSubscribe"}
                        />
                      </div>

                      <div style={{ marginTop: "5px" }}>
                        {isEnabled ? (
                          <Field
                            validationMessage={
                              <Text
                                style={{
                                  color: "green",
                                }}
                              >
                                {t("requestFormAdminFormEditor.avaliable")}
                              </Text>
                            }
                            validationState="none"
                          ></Field>
                        ) : (
                          <Field
                            validationMessage={
                              <Text
                                style={{
                                  color: "black",
                                }}
                              >
                                {t("requestFormAdminFormEditor.disabled")}
                              </Text>
                            }
                            validationState="none"
                          ></Field>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          marginTop: "5px",
                          display: "flex",
                          color: "black",
                        }}
                      >
                        <div style={{ marginRight: "10px", marginTop: "5px" }}>
                          <Spinner size="tiny" label= {t("requestFormAdminFormEditor.loading")}></Spinner>
                        </div>
                     
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <Divider></Divider>

          {/* <div
            style={{
              marginTop: "20px",
              position: "absolute",
              top: "120px",
              left: "50px",
              display: "flex",
            }}
          >
            <ThemeSelector />
            <ExampleForm />
          </div> */}

          <div className="container">
            <div className="row-pickup">
              {currentCustom === "pickTheme" && (
                <>
                  <div className="column">
                    {/* <hr></hr> */}
                    <div
                      style={{
                        width: "900px",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignContent: "flex-start",
                        textAlign: "center",
                        height: "80px",
                      }}
                    >
                      {" "}
                      <h2 style={{ color: "black" }}>
                        {t("requestFormAdminFormEditor.selectThemeForForm")}
                      </h2>
                    </div>
                    <ThemeSelector
                      ThemeForm={ThemeForm}
                      setThemeForm={setThemeForm}
                      EditConfirm={EditConfirm}
                      EditUnsuccess={EditUnsuccess}
                      formId={formId}
                      loading={loading}
                      setLoading={setLoading}
                      setDismissTimeout={setDismissTimeout}
                      inProgress={inProgress}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",

                      textAlign: "center",
                      flexDirection: "column",
                      position: "relative",
                    }}
                  >
                    {/* <div>
                    <ExampleForm />
                  </div> */}
                    <div
                      style={{
                        width: "900px",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignContent: "flex-start",
                        textAlign: "center",
                        height: "80px",
                      }}
                    >
                      {" "}
                      <Label className={styles.title}>
                        {t("requestFormAdminFormEditor.exampleThemeForForm")}
                      </Label>
                    </div>
                    {!loading ? (
                      <div
                        style={{
                          paddingLeft: "2rem",
                          paddingRight: "2rem",
                          paddingTop: "1rem",
                          paddingBottom: "1rem",
                          backgroundColor: "white",
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "row",
                          justifyContent: "center",
                          width: "830px",
                        }}
                      >
                        <div>
                          <ExampleFormFirstPage contentState={contentState} />
                        </div>
                        <div>
                          <ExampleFormSecondPage contentState={contentState} />
                        </div>
                        <div>
                          <ExampleFormThirdPage
                            contentStateSecend={contentStateSecend}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          paddingLeft: "2rem",
                          paddingRight: "2rem",
                          paddingTop: "1rem",
                          paddingBottom: "1rem",
                          backgroundColor: "white",

                          display: "flex",
                          alignItems: "center",
                          flexDirection: "row",

                          width: "830px",
                          justifyContent: "space-between",
                        }}
                      >
                        <Skeleton>
                          <SkeletonItem
                            style={{
                              maxWidth: "380px",
                              height: "300px",
                            }}
                          >
                            <div
                              style={{
                                width: "270px",
                                height: "50px",
                              }}
                            ></div>
                          </SkeletonItem>{" "}
                        </Skeleton>
                        <Skeleton>
                          <SkeletonItem
                            style={{
                              maxWidth: "380px",
                              height: "300px",
                            }}
                          >
                            <div
                              style={{
                                width: "270px",
                                height: "50px",
                              }}
                            ></div>
                          </SkeletonItem>{" "}
                        </Skeleton>
                        <Skeleton>
                          <SkeletonItem
                            style={{
                              maxWidth: "380px",
                              height: "300px",
                            }}
                          >
                            <div
                              style={{
                                width: "270px",
                                height: "50px",
                              }}
                            ></div>
                          </SkeletonItem>{" "}
                        </Skeleton>
                      </div>
                    )}
                  </div>
                </>
              )}
              {currentCustom === "qrCodeEdit" && (
                <div className="column" style={{ color: "black" }}>
                  {/* <hr></hr> */}
                  <div
                    style={{
                      width: "900px",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignContent: "flex-start",
                      textAlign: "center",
                      height: "80px",
                    }}
                  >
                    {" "}
                    <h2>{t("requestFormAdminFormEditor.printQrCode")}</h2>
                  </div>

                  <ManagementQrCode
                    EditConfirm={EditConfirm}
                    EditUnsuccess={EditUnsuccess}
                    CopySuccess={CopySuccess}
                    setIsLoadComplete={setIsLoadComplete}
                    formId={formId}
                    setFormId={setFormId}
                    isEnabled={isEnabled}
                    setIsEnabled={setIsEnabled}
                    setSavedData={setSavedData}
                    themeLoading={themeLoading}
                    setThemeLoading={setThemeLoading}
                    logoLoading={logoLoading} 
                    setLogoLoading={setLogoLoading}
                    urlId={urlId} 
                    seturlId={seturlId}
                    logoIsHere={logoIsHere}
                    setLogoIsHere={setLogoIsHere}
                    logoIsHereForCompare={logoIsHereForCompare}
                    setLogoIsHereForCompare={setLogoIsHereForCompare}
                    setPolicyMessage={setPolicyMessage}
                    setDismissTimeout={setDismissTimeout}
                    inProgress={inProgress}
                  />
                </div>
              )}
            </div>
          </div>
             
         
           {currentCustom === "managementPolicy" && (
              <>
               <div className="container-form">
                
                <ManagementPolicyPrivacy  setPolicyMessage={setPolicyMessage} policyMessage={policyMessage} formId={formId}  isLoadComplete={isLoadComplete} setIsLoadComplete={setIsLoadComplete} />
                </div>
              </>
            )}
      
           
      
          <div className="container-form">
            {currentCustom === "addTextForm" && (
              <div className="row">
                <div className="column">
                  {/* <hr></hr> */}

                  <div
                    style={{
                      width: "900px",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignContent: "flex-start",
                      textAlign: "center",
                      height: "80px",
                    }}
                  >
                    {" "}
                    <h2 style={{ color: "black" }}>
                      {t("requestFormAdminFormEditor.addingTextToForm")}
                    </h2>
                  </div>
                  {isLoadComplete ? (
                    <div>
                      <div className="stack-background">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Text
                            className={styles.title}
                            style={{ color: "black" }}
                          >
                            {t("requestFormAdminFormEditor.addingFirstPage")}
                          </Text>

                          <div
                            // className="fieldtextbackground"
                            style={{
                              backgroundColor: "white",
                              marginTop: "10px",
                            }}
                          >
                            <Editor
                              editorState={editorState}
                              toolbarClassName="editor-toolbar"
                              wrapperClassName="editor-wrapper"
                              editorClassName="editor"
                              onEditorStateChange={handleEditorStateChange}
                              // onEditorStateChange={this.onEditorStateChange}
                              onContentStateChange={handleContentStateChange}
                              // toolbar={toolbar}
                              
                              customBlockRenderFunc={myBlockStyleFn}
                              toolbar={{
                                inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                link: { inDropdown: true },
                                history: { inDropdown: true },
                                fontFamily: {
                                      options: [
                                        'Arial',          // Web-safe
                                        'Georgia',        // Web-safe
                                        'Tahoma',         // Web-safe
                                        'Times New Roman',// Web-safe
                                        'Verdana',        // Web-safe
                                        'Courier New',    // Web-safe
                                        'Trebuchet MS',   // Web-safe
                                        'Lucida Console', // Web-safe
                                        'Comic Sans MS',  // Web-safe
                                      ],
                                    },
                                // image: {
                                //   uploadCallback: uploadImageCallBack,
                                //   alt: { present: true, mandatory: true },
                                // },
                                fontSize: {
                                  options: [
                                    8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36,
                                  ],

                                  className: undefined,
                                  component: undefined,
                                  dropdownClassName: undefined,
                                  defaultFontSize: 96,
                                },
                              }}
                               localization={localization[locale]}
                              // localization={{
                              //   locale: "es",
                              //   translations: es,
                              // }}
                              spellCheck
                              // ref={EditorTextRefFirst}
                              // toolbarCustomButtons={[<CustomComponent />]}
                              // onFocus={() => {
                              //   handleContentStateChange(contentInitialValue);
                              //   handleEditorStateChange(initialValue);
                              // }}
                            />
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "50px",
                          }}
                        >
                          <Text
                            className={styles.title}
                            style={{ color: "black" }}
                          >
                            {t("requestFormAdminFormEditor.addingLastPage")}
                          </Text>

                          <div
                            // className="fieldtextbackground"
                            style={{
                              backgroundColor: "white",
                              marginTop: "10px",
                            }}
                          >
                            <Editor
                              editorState={editorStateSecend}
                              toolbarClassName="editor-toolbar"
                              wrapperClassName="editor-wrapper"
                              editorClassName="editor"
                              onEditorStateChange={
                                handleEditorStateChangeSecend
                              }
                              // onContentStateChange={
                              //   handleContentStateChangeSecend
                              // }
                              // toolbar={toolbar}
                              toolbar={{
                                inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                link: { inDropdown: true },
                                history: { inDropdown: true },
                                fontFamily: {
                                      options: [
                                        'Arial',          // Web-safe
                                        'Georgia',        // Web-safe
                                        'Tahoma',         // Web-safe
                                        'Times New Roman',// Web-safe
                                        'Verdana',        // Web-safe
                                        'Courier New',    // Web-safe
                                        'Trebuchet MS',   // Web-safe
                                        'Lucida Console', // Web-safe
                                        'Comic Sans MS',  // Web-safe
                                      ],
                                    },
                                // image: {
                                //   uploadCallback: uploadImageCallBack,
                                //   alt: { present: true, mandatory: true },
                                // },
                                fontSize: {
                                  options: [
                                    8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36,
                                  ],

                                  className: undefined,
                                  component: undefined,
                                  dropdownClassName: undefined,
                                  defaultFontSize: 96,
                                },
                              }}
                               localization={localization[locale]}
                              // localization={{
                              //   locale: "es",
                              //   translations: es,
                              // }}
                              spellCheck
                              // stripPastedStyles
                              // ref={EditorTextRefSecond}
                              // toolbarCustomButtons={[<CustomComponent />]}
                            />
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "50px",
                          }}
                        >
                          <Text
                            className={styles.title}
                            style={{ color: "black" }}
                          >
                            {t("requestFormAdminFormEditor.addingCloseForm")}
                          </Text>

                          <div
                            style={{
                              backgroundColor: "white",
                              marginTop: "10px",
                            }}
                          >
                            <Editor
                              editorState={editorStateThird}
                              toolbarClassName="editor-toolbar"
                              wrapperClassName="editor-wrapper"
                              editorClassName="editor"
                              onEditorStateChange={handleEditorStateChangeThird}
                              // onContentStateChange={handleContentStateChangeThird}
                              // toolbar={toolbar}
                              toolbar={{
                                inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                link: { inDropdown: true },
                                history: { inDropdown: true },
                                fontFamily: {
                                      options: [
                                        'Arial',          // Web-safe
                                        'Georgia',        // Web-safe
                                        'Tahoma',         // Web-safe
                                        'Times New Roman',// Web-safe
                                        'Verdana',        // Web-safe
                                        'Courier New',    // Web-safe
                                        'Trebuchet MS',   // Web-safe
                                        'Lucida Console', // Web-safe
                                        'Comic Sans MS',  // Web-safe
                                      ],
                                    },
                                fontSize: {
                                  options: [
                                    8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36,
                                  ],

                                  className: undefined,
                                  component: undefined,
                                  dropdownClassName: undefined,
                                  defaultFontSize: 96,
                                },
                                // image: {
                                //   uploadCallback: uploadImageCallBack,
                                //   alt: { present: true, mandatory: true },
                                // },
                              }}
                               localization={localization[locale]}
                              // localization={{
                              //   locale: "es",
                              //   translations: es,
                              // }}
                              spellCheck
                              // stripPastedStyles
                              // ref={EditorTextRefSecond}
                              // toolbarCustomButtons={[<CustomComponent />]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="stack-background-for-loading">
                      {/* <Spinner style={{ justifySelf: "center" }}>
                      <Text color="black" style={{ color: "black" }}>
                        กำลังโหลด ...
                      </Text>
                    </Spinner> */}

                      <div
                        style={{
                          display: "flex",
                          width: "830px",
                          justifyContent: "center",
                        }}
                      >
                        <div style={{ marginRight: "10px", marginTop: "-3px" }}>
                          <Spinner size="extra-large"  label= {t("requestFormAdminFormEditor.loading")}></Spinner>
                        </div>
                       
                      </div>
                    </div>
                  )}

                  {isLoadComplete && (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <Dialog modalType="modal">
                        <DialogTrigger disableButtonEnhancement>
                          <Button
                            appearance="primary"
                            style={{ marginRight: "10px" }}
                            disabled={!isLoadComplete}
                          >
                            {t("requestFormAdminFormEditor.save")}
                          </Button>
                        </DialogTrigger>

                        <DialogSurface className="fluentui-dialog">
                          <DialogBody className="dialog-body">
                            <DialogTitle>
                              {" "}
                              {t("requestFormAdminFormEditor.confirmForSave")}
                            </DialogTitle>
                            <DialogContent>
                              {" "}
                              {t("requestFormAdminFormEditor.confirmToSave")}
                            </DialogContent>
                            <DialogActions>
                              <DialogTrigger disableButtonEnhancement>
                                <Button
                                  onClick={handleSavePreviewFirst}
                                  appearance="primary"
                                  className="button-dialog"
                                >
                                  {t("requestFormAdminFormEditor.confirm")}
                                </Button>
                              </DialogTrigger>

                              <DialogTrigger disableButtonEnhancement>
                                <Button
                                  appearance="secondary"
                                  className="button-dialog"
                                >
                                  {t("requestFormAdminFormEditor.cancel")}
                                </Button>
                              </DialogTrigger>
                            </DialogActions>
                          </DialogBody>
                        </DialogSurface>
                      </Dialog>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* <div className="container-form"></div> */}
      </div>
            }
    </div>

      </>
  );
};

export default ManagementForm;
